import { useMemo } from 'react';

import { usePsfSharePageData, usePsfSharePageFcm } from 'src/app/pages/psf/share/pageContext';

import type { BanditVariant } from '../../types';

import { getPathSuffixGenerator, getPathSuffixGeneratorV2 } from './shared/pathSuffix';
import { useGenHeadlineOrMitaBanditVariantData } from './variantData';

type Result = Readonly<Partial<Record<'facebook' | 'whatsapp' | 'copy' | 'twitter', BanditVariant>>>;

export function useHeadlineBanditVariants(): Result {
	const {
		data: {
			petition: { headlineBandits, mitaBandits },
		},
	} = usePsfSharePageData();

	const { starfishSmartImageBanditsV2 } = usePsfSharePageFcm();
	const genVariantData = useGenHeadlineOrMitaBanditVariantData();

	return useMemo(
		() =>
			starfishSmartImageBanditsV2
				? {
						facebook: genVariantData(
							mitaBandits.mitaSmartImage || headlineBandits.facebookHeadline,
							getPathSuffixGeneratorV2('facebook'),
						),
						copy: genVariantData(
							mitaBandits.mitaSmartImage || headlineBandits.copylinkHeadline,
							getPathSuffixGeneratorV2('copy'),
						),
						whatsapp: genVariantData(
							mitaBandits.mitaSmartImage || headlineBandits.whatsappHeadline,
							getPathSuffixGeneratorV2('whatsapp'),
						),
						twitter: genVariantData(mitaBandits.mitaSmartImage, getPathSuffixGeneratorV2('twitter')),
					}
				: {
						facebook: genVariantData(
							mitaBandits.mitaSmartImage || headlineBandits.facebookHeadline,
							getPathSuffixGenerator('facebook'),
						),
						copy: genVariantData(headlineBandits.copylinkHeadline, getPathSuffixGenerator('copy')),
						whatsapp: genVariantData(headlineBandits.whatsappHeadline, getPathSuffixGenerator('whatsapp')),
					},
		[starfishSmartImageBanditsV2, headlineBandits, mitaBandits, genVariantData],
	);
}
